import { render, staticRenderFns } from "./FlashNewsEditView.vue?vue&type=template&id=730c3db8&"
import script from "./FlashNewsEditView.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('730c3db8')) {
      api.createRecord('730c3db8', component.options)
    } else {
      api.reload('730c3db8', component.options)
    }
    module.hot.accept("./FlashNewsEditView.vue?vue&type=template&id=730c3db8&", function () {
      api.rerender('730c3db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/flashNews/FlashNewsEditView.vue"
export default component.exports